import React, {useState} from 'react';

import {TextPropsSchema} from '@usewaypoint/block-text';

import BaseSidebarPanel from './helpers/BaseSidebarPanel';
import BooleanInput from './helpers/inputs/BooleanInput';
import TextInput from './helpers/inputs/TextInput';
import MultiStylePropertyPanel from './helpers/style-inputs/MultiStylePropertyPanel';


export default function TextSidebarPanel({data, setData}) {
    const [, setErrors] = useState(null);

    const updateData = (d) => {
        const res = TextPropsSchema.safeParse(d);
        console.log('entra')
        if (res.success) {
            setData(res.data);
            setErrors(null);
        } else {
            setErrors(res.error);
        }
    };

    return (
        <BaseSidebarPanel>
            <TextInput
                label="Content"
                rows={5}
                defaultValue={data.props?.text ?? ''}
                onChange={(text) => updateData({...data, props: {...data.props, text}})}
            />
            <BooleanInput
                label="Markdown"
                defaultValue={data.props?.markdown ?? false}
                onChange={(markdown) => updateData({...data, props: {...data.props, markdown}})}
            />

            <MultiStylePropertyPanel
                names={['color', 'backgroundColor', 'fontFamily', 'fontSize', 'fontWeight', 'textAlign', 'padding']}
                value={data.style}
                onChange={(style) => updateData({...data, style})}
            />
        </BaseSidebarPanel>
    );
}
